module.exports = __webpack_public_path__ + "img/submit-bg.ad782e5.png";